import { PageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.en.ts';

export const pageTitlesTranslation: PageTitlesTranslation = {
  analysisRemarks: 'Uwagi do analiz',
  backTo: 'Wróć do',
  discovery: 'Discovery',
  experienceCompanies: 'Firmy doświadczenia',
  interviewSimulation: 'Symulacja rozmowy',
  knowMe: 'KnowMe',
  meetings: 'Spotkania',
  processDetails: 'Szczegóły procesu',
  processes: 'Procesy',
  processTemplates: 'Wzory procesów',
  statistics: 'Statystyki',
};
